import slotShouldForwardProp from "./slotShouldForwardProp.es.js";
const rootShouldForwardProp = (prop) => slotShouldForwardProp(prop) && prop !== "classes";
const rootShouldForwardProp$1 = rootShouldForwardProp;
export {
  rootShouldForwardProp$1 as default
};
//# sourceMappingURL=rootShouldForwardProp.es.js.map
